import React from "react";

interface VisulaIconIntRevProps {
  width?: string;
  height?: string;
  isActive?: boolean;
}

const VisulaIconIntRev: React.FC<VisulaIconIntRevProps> = ({
  width = "24px",
  height = "22px",
  isActive = false,
}) => {
  const fillColor = `var(--${isActive ? "theme-primary-color" : "theme-inactive-color"})`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "16"}
      height={height ?? "16"}
      viewBox="0 0 16 16"
      fill={fillColor}
    >
      <path
        d="M6.74997 0.75H9.24997M6.74997 15.25H9.24997M7.99997 1V3.25M7.99997 12.75V15M12.2426 1.98959L14.0104 3.75736M1.98956 12.2426L3.75733 14.0104M12.9497 3.05025L11.3587 4.64124M4.64121 11.3588L3.05022 12.9497M15.25 6.74991V9.24991M0.75 6.74991V9.24991M15 7.99991H12.75M3.25 7.99991H1M14.0104 12.2426L12.2426 14.0104M3.75733 1.98959L1.98956 3.75736M12.9497 12.9497L11.3587 11.3588M4.64121 4.64124L3.05022 3.05025M12.25 8C12.25 10.3472 10.3472 12.25 7.99997 12.25C5.65276 12.25 3.74997 10.3472 3.74997 8C3.74997 5.65279 5.65276 3.75 7.99997 3.75C10.3472 3.75 12.25 5.65279 12.25 8Z"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: fillColor }}
      />
    </svg>
  );
};

export default VisulaIconIntRev;
